/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */

enum OrganType {
    Normal = "Normal",
    Reproductive = "Reproductive",
    Vegetative = "Vegetative",
    None = "None"
}

export default OrganType;
